import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=ecdf1bbe&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"
import style0 from "./UserEdit.vue?vue&type=style&index=0&id=ecdf1bbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdf1bbe",
  null
  
)

export default component.exports